<div class="py-14 bg-white">
  <div class="max-w-[1442px] mx-auto">
    <div class="px-3 lg:max-w-[1080px] flex flex-col lg:flex-row h-auto mx-auto">
      <div class="flex-shrink-0 w-[300px] custom-tabset">
        <div class="w-full">
          <div class="flex !justify-center items-center pe-4 tabs-items border-b">
            <button class="text-start p-4 font-semibold w-full">
              Topics
            </button>
          </div>
          <ng-container *ngFor="let tab of tabs; let i = index">
            <div class="flex !justify-center items-center pe-4 tabs-items border-b"
                 [ngClass]="{
                   'active font-semibold text-[--primary-color] border-b-2 border-solid accordion-border-b ': selectedStatus == i + 1,
                   'font-normal fg-secondary': selectedStatus != i + 1,
                   'border-b': i < tabs.length - 1
                 }">
              <button class="text-start p-4 text-sm w-full" (click)="changeStatus(i + 1)">
                {{ tab.label }}
              </button>
              <svg class="-rotate-90" width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg"
                   [ngStyle]="{'fill': selectedStatus == i + 1 ? '#00DF9A' : 'black'}">
                <path d="M15.6 5.8335L10.5 10.9885L5.39996 5.8335L3.83329 7.42829L10.5 14.1668L17.1666 7.42829L15.6 5.8335Z"/>
              </svg>
            </div>
          </ng-container>
        </div>
      </div>
      <div class="flex-1 pl-4">
        <ng-container *ngFor="let summary of summaries">
          <div *ngIf="selectedStatus === summary.status">
            <div class="tab-content">
              <section class="faq-section">
                <ul class="list-none p-0">
                  <li *ngFor="let item of summary.content; let i = index" class="relative ">
                    <button [ngClass]="{'accordion-border-b': openedIndex === i}" type="button" class="w-full bg-[#F6F6F6] " (click)="toggleDetails(i)">
                      <div class="flex items-center justify-between px-2">
                        <h1 class="!text-[1rem] leading-[20px] "><span  class="index" [ngClass]="{'!text-[#00DF9A]': openedIndex === i}">{{ item.index }}</span> {{ item.question }}</h1>
                      <svg  [ngClass]="{'transform rotate-180': openedIndex === i}" class="w-5 h-5 transition-transform duration-300" width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg" fill="black">
                                <path d="M15.6 5.8335L10.5 10.9885L5.39996 5.8335L3.83329 7.42829L10.5 14.1668L17.1666 7.42829L15.6 5.8335Z" />
                            </svg>
                      </div>
                    </button>
                    <div #detailsContainer class="relative overflow-hidden transition-all duration-700 " [ngStyle]="{'max-height': openedIndex === i ? (detailsContainer.scrollHeight + 'px') : '0'}">
                      <div class="px-6 py-3">
                        <p class="bg-[#F6F6F6]">{{ item.answer }}</p>
                      </div>
                    </div>
                  </li>
                </ul>
              </section>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
